import { render, staticRenderFns } from "./EnviarAssinatura.vue?vue&type=template&id=06e8fbbd"
import script from "./EnviarAssinatura.vue?vue&type=script&lang=js"
export * from "./EnviarAssinatura.vue?vue&type=script&lang=js"
import style0 from "./EnviarAssinatura.vue?vue&type=style&index=0&id=06e8fbbd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports